import React from 'react';
import classNames from 'classnames';
import { Icon } from 'ui';

const SelectableItem = ({ onClick, label, icon, shrinked }) => (
  <div
    className={classNames('AssignableItem', {
      'AssignableItem--selected': true,
      'AssignableItem--small': true,
      'AssignableItem--shrinked': shrinked,
    })}
  >
    <span className="AssignableItem-label">
      {icon && <Icon name={icon} className="AssignableItem-icon" />}
      {label}
    </span>
    {onClick && (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
      <div className="AssignableItem-removeIcon" onClick={onClick}>
        <Icon name="error" />
      </div>
    )}
  </div>
);

export default SelectableItem;
